import PropTypes from 'prop-types';

export const assignmentSubmissionProps = {
  submission: PropTypes.object,
  setIsFormModified: PropTypes.func.isRequired,
  setUpdatingCommentComplete: PropTypes.func.isRequired,
  setIsSubmitButtonClicked: PropTypes.func.isRequired,
  isSaveButtonClicked: PropTypes.bool.isRequired,
  isSubmitButtonClicked: PropTypes.bool.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  dueOn: PropTypes.string.isRequired,
  attachmentRequired: PropTypes.bool.isRequired,
  commentRequired: PropTypes.bool.isRequired,
  onSaveOrSubmit: PropTypes.func,
  shouldHideButtons: PropTypes.bool.isRequired,
  submissionHandler: PropTypes.func.isRequired,
  onAssignmentLocked: PropTypes.func.isRequired,
  onLessonLocked: PropTypes.func.isRequired,
};

export const isSubmissionRequired = assignment =>
  assignment.commentRequired || assignment.attachmentRequired;
